export default {
  "name": "NCNumber",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCNumber",
  "label": "数字",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "scale": {
        "title": "精度",
        "description": "精度",
        "type": "number",
        "default": 0
      },
      "noDataFormat": {
        "title": "非格式化数据",
        "description": "非格式化数据",
        "type": "boolean"
      },
      "fieldid": {
        "title": "自动化Id",
        "description": "自动化Id",
        "type": "string"
      },
      "verify": {
        "title": "校验",
        "description": "校验",
        "type": "boolean",
        "default": true
      },
      "value": {
        "title": "值",
        "description": "值",
        "type": "string",
        "default": ""
      },
      "disabled": {
        "title": "禁用",
        "description": "禁用",
        "type": "boolean",
        "default": false
      },
      "maxlength": {
        "title": "最大长度",
        "description": "最大长度",
        "type": "number"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}